import "./HollywoodSmile.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import TreatmentDetails from "./sections/TreatmentDetails";
import Projects from "./sections/Projects";
import Footer from "@/reusable_sections/Footer";
export default function HollywoodSmilePage() {
  return <div>
      <Header />
      <Hero />
      <TreatmentDetails />
      <Projects />
      <Footer />
    </div>;
}